import React from 'react';
import ButtonStyles from './styles';

const NavButton = props => {
	return (
		<ButtonStyles {...props} className={`nav-button ${props.className}`}>
			{props.content}
		</ButtonStyles>
	);
};

export default NavButton;
